import { atom, useAtomValue } from 'jotai'
import { store } from './general'

const appResetAtom = atom(false)

export const setAppReset = (isReset: boolean) => {
  store.set(appResetAtom, isReset)
}

export const useAppReset = () => {
  return useAtomValue(appResetAtom)
}

export default appResetAtom
